import React, {} from 'react';
import { adminBaseURL, buildFormDataFromObject } from '../utils/commonUtils';
import { workspaceSizeAlert, checkImagesSize, checkContentAttachmentsLimit, checkUploadLimit } from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { contentActions } from '../actions';
import { contentConstants } from '../constants';
import { content } from '../reducers/content.reducer';

// For downloading attachment to card only
function HiddenContentImageUploader(props) {
  const {
    fileInputRef,
    workspace_id,
    content_group_id,
    content_popup_notification,
    workspace
  } = props
  const dispatch = useDispatch();
  const { contents, content_loading, attachment_downloading } = useSelector(state => state.content);

  const addFile = e => {
    if (content_loading || attachment_downloading) {
      e.preventDefault();
      return;
    }
    const chosenFiles = Array.prototype.slice.call(e.target.files).reverse();
    handleUploadFiles(chosenFiles);

    e.target.value = '';
  }

  const handleUploadFiles = (arrayFiles)  => {
      let limitExceeded = checkImagesSize(arrayFiles, workspace?.personal);
      let isUploadLimitReached = checkUploadLimit({
          currentCount: arrayFiles.length
      });

      let { isLimitReachedWithSelectedFiles, isLimitReached } = checkContentAttachmentsLimit({
        attachments: contents || [],
        selected_files: arrayFiles,
        limit: contentConstants.MAX_ATTACHMENT_COUNT,
        alert: true
      })
      
      if (!limitExceeded && !isLimitReachedWithSelectedFiles && arrayFiles.length > 0 && !isUploadLimitReached) {
        workspaceSizeAlert(workspace)
        let formData = new FormData();
        arrayFiles.forEach((item, index) => formData.append("[content][attachment]["+index+"]", item))

        dispatch(contentActions.createContent(formData, workspace_id, content_group_id, content_popup_notification ));
      }
  }

  return (
    <input
      type="file"
      onChange={addFile}
      ref={fileInputRef}
      hidden
      multiple
      accept="image/jpg, image/jpeg, image/png, image/gif, image/webp"
    />
  );
}

export { HiddenContentImageUploader };
